<template>
    <div class="uslugi">
        <h4 style="align-self: flex-start;">Пациентам</h4>
        <div class="patients">
            <div v-if="desktop" style="width:25%; padding:2rem">
                <div class="info" @click="chooseMenu(commonInfo, { title: 'Общая информация', value: 'common_info'})">Общая информация</div>
                <div class="info" v-b-toggle.collapse-1>Услуги <span class="material-icons">keyboard_arrow_down</span></div>
                <b-collapse id="collapse-1" class="mt-2">
                    <ol class="rounded">
                        <li @click="currentService(service)" v-for="service in services" :key="service.text"><a>{{service.text}}</a></li>
                    </ol>
                </b-collapse>
                <div @click="chooseMenu(prices, { title:'Цены', value: 'prices'})" class="info">Цены</div>
            </div>
            <b-dropdown v-else variant="info" style="width:100%">
                <template #button-content>
                    {{currentMenu.title}}
                </template>
                <b-dropdown-item @click="chooseMenu(commonInfo, { title: 'Общая информация', value: 'common_info'})">Общая информация</b-dropdown-item>
                <b-dropdown-group id="dropdown-group-2" header="Услуги">
                    <b-dropdown-item-button @click="currentService(service)" v-for="service in services" :key="service.text">{{service.text}}</b-dropdown-item-button>
                </b-dropdown-group>
                <b-dropdown-item @click="chooseMenu(prices, { title:'Цены', value: 'prices'})">Цены</b-dropdown-item>
            </b-dropdown>
            <div :style="{ width: desktop ? '75%' : '100%'}">
                <h5>{{currentMenu.title}}</h5>
                <b-button v-if="isOrgAdmin" variant="info" @click="openEdit()">Редактировать</b-button>
                <div id="viewer">
                </div>
            </div>
        </div>
        <Dialog v-if="open_edit">
            <h4 slot="header">Редактирование</h4>
            <div slot="body" id="editor" style="max-height:200px;overflow:auto">
            </div>
            <div slot="footer">
                <b-button variant="info" @click="edit_content()">Сохранить</b-button>
                <b-button variant="danger" @click="closeEdit()">Отменить</b-button>
            </div>
        </Dialog>
    </div>
</template>

<script>
import Dialog from '@app/views/custom-components/modals/edit-modal.vue';
import { organizationApi } from '@app/services';

export default {
    components: {
        Dialog
    },
    data() {
        return {
            desktop: null,
            open_edit: false,
            quill: null,
            edit_quill: null,
            mainInfo: true,
            currentMenu: { title: 'Общая информация', value: 'common_info'},
            currentSrv: null
        };
    },
    computed: {
        services() {
            return this.$store.state.clinic.organization.form.front.services;
        },
        commonInfo() {
            return this.$store.state.clinic.organization.form.front.common_info ?
            this.$store.state.clinic.organization.form.front.common_info :  [{insert: 'Не заполнено'}];
        },
        prices() {
            return this.$store.state.clinic.organization.form.front.prices ?
            this.$store.state.clinic.organization.form.front.prices : [{insert: 'Не заполнено'}];
        },
        isOrgAdmin() {
            const role = this.$store.state.clinic.roles.filter(obj => obj === 'orgadmin')[0];
            return role ? true : false;
        },
    },
    created() {
        window.addEventListener('resize', this.resizeHandler);
    },
    destroyed() {
        window.removeEventListener('resize', this.resizeHandler);
    },
    mounted() {
        this.quill = new Quill('#viewer', {
         /*   theme: 'bubble',  растягивает по высоте на мозилле*/
            readOnly:true
        });
        console.log(this.$store.state.clinic);
        if (this.$route.query.page) {
            if (this.$route.query.page === 'common_info') {
                this.chooseMenu(this.commonInfo, { title: 'Общая информация', value: 'common_info'});
            } else if (this.$route.query.page === 'prices') {
                this.chooseMenu(this.prices, { title:'Цены', value: 'prices'});
            } else {
                const srv = this.services.filter(obj => obj.text === this.$route.query.page)[0];
                if (srv) {
                    this.currentService(srv);
                }
            }
        } else {
            this.quill.setContents(this.commonInfo);
        }
        this.desktop = window.innerWidth > 1100;
    },
    methods: {
        closeEdit() {
            this.open_edit = false;
        },
        openEdit() {
            this.open_edit = true;
            const toolbarOptions = [
                    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    ['blockquote'],

                    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent

                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                    [{ 'font': [] }],
                    [{ 'align': [] }],
                    ['image'], ['link']

                ];
            setTimeout(() => { this.edit_quill = new Quill('#editor', {
                theme: 'snow',
                readOnly:false,
                modules: {
                        toolbar: toolbarOptions
                    }
            });
            this.edit_quill.setContents(this.quill.getContents());
            }, 100);
            
        },
        edit_content() {
            this.quill.setContents(this.edit_quill.getContents());
            const front = this.$store.state.clinic.organization.form.front;
            let backup;
            if (this.currentMenu.value === 'services') {
                backup = Object.assign([], front[this.currentMenu.value].services);
                front[this.currentMenu.value][front.services.findIndex(obj => obj.text === this.currentSrv.text)].content = Object.assign({}, this.edit_quill.getContents());
            } else {
                backup = Object.assign({}, front[this.currentMenu.value]);
                front[this.currentMenu.value] = Object.assign({}, this.edit_quill.getContents());
            }
            organizationApi.update({front: front}).then(res => {
                this.open_edit = false;
            }).catch(error => {
                console.log(error);
                front[this.currentMenu.value] = backup.length > 0 ? Object.assign([], backup) : Object.assign({}, backup);
            });
        },
        currentService(srv) {
            if (this.services) {
                this.currentSrv = srv;
                this.currentMenu = { value: 'services', title: `Услуги: ${srv.text}`};
                const curSrv = srv.content;
                if (curSrv) {
                    this.quill.setContents(curSrv);
                } else {
                    this.quill.setText('Не заполнено');
                }
            }
        },
        chooseMenu(content, menu) {
            this.$route.query.page = menu.value;
            console.log(this.$route);
            this.currentMenu = menu;
            this.quill.setContents(content);
        },
        resizeHandler({ target }) {
            const isDesktop = target.innerWidth > 1100;
            let bool;
            if (isDesktop) {
                if (!this.desktop) {
                bool = true;
                }
            } else if (this.desktop) {
                bool = false;
            }
            this.desktop = isDesktop;
        },
    }
};
</script>

<style lang="scss" scoped>
::v-deep .modal-container {
    width:90%;
}
    .rounded {
counter-reset: li; 
list-style: none; 
font: 16px "Trebuchet MS", "Lucida Sans";
padding: 0;
text-shadow: 0 1px 0 rgba(255,255,255,.5);
cursor: pointer;
}
.rounded a {
position: relative;
display: block;
padding: .4em .4em .4em 2em;
margin: .5em 0;
background: #DAD2CA;
color: #444;
text-decoration: none;
border-radius: .3em;
transition: .3s ease-out;
//height:30px;
}
.rounded a:hover {background: #E9E4E0;}
.rounded a:hover:before {transform: rotate(360deg);}
.rounded a:before {
content: counter(li);
counter-increment: li;
position: absolute;
left: -1.3em;
top: 50%;
margin-top: -1.3em;
background: #8FD4C1;
height: 30px;
width: 30px;
line-height: 2em;
border: .3em solid white;
text-align: center;
font-weight: bold;
border-radius: 2em;
transition: all .3s ease-out;
}
li {
    margin:1rem;
}

.info {
    border-radius: .3em;
    background: #DAD2CA;
    color: #444;
    padding: .4em .4em .4em 2em;
    margin: .4em;
    font: 18px "Trebuchet MS", "Lucida Sans";
    text-shadow: 0 1px 0 rgba(255,255,255,.5);
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}
.info:hover {
    background: #E9E4E0;
}
.uslugi {
    padding:1rem 4rem 1rem 4rem;
}
.patients {
    display:flex;
    flex-direction:row;
    width:100%;
}
@media screen and (max-width: 1024px) {
.uslugi {
    padding:0;
}
.patients {
    display:flex;
    flex-direction:column;
}
}
</style>